import React, { useState, useEffect } from 'react';
import { Form } from 'react-bootstrap';
import CurrencyInput from '../common/CurrencyInput';
import { formatCurrency } from '../../utils/formatters';
import { calculateAgentCommission } from '../../utils/calculations';
import { useCalculator } from '../../contexts/CalculatorContext';

interface AgentCommissionPriceProps {
  entity: string;
}

const AgentCommissionPrice: React.FC<AgentCommissionPriceProps> = ({ entity }) => {
  const { vatRate } = useCalculator();
  const [propertyPrice, setPropertyPrice] = useState<number>(0);
  const [commissionRate, setCommissionRate] = useState<number>(10);
  const [result, setResult] = useState<{
    commission: number;
    vatOnCommission: number;
    grossPriceLess: number;
    grossPricePlus: number;
  } | null>(null);

  useEffect(() => {
    if (propertyPrice > 0 && commissionRate > 0 && commissionRate < 99) {
      const calc = calculateAgentCommission(propertyPrice, commissionRate, vatRate);
      setResult(calc);
    } else {
      setResult(null);
    }
  }, [propertyPrice, commissionRate, vatRate]);

  return (
    <div className="p-2">
      <CurrencyInput value={propertyPrice} onChange={setPropertyPrice} label="Property Price" required />

      <Form.Group className="mb-2">
        <div className="form-group has-float-label">
          <Form.Control
            type="number"
            min="0.1"
            max="99"
            step="0.1"
            value={commissionRate}
            onChange={(e) => setCommissionRate(parseFloat(e.target.value) || 10)}
            required
            placeholder=" "
          />
          <span className="required">Professional Fee Estate Agency (%)</span>
        </div>
      </Form.Group>

      {result && commissionRate < 99 && commissionRate > 0 && (
        <table className="table table-sm mt-2" style={{ fontSize: '13px' }}>
          <thead>
            <tr>
              <th colSpan={2} className="text-secondary border-0 py-1" style={{ fontSize: '10px', letterSpacing: '0.5px' }}>
                CALCULATED
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="border-0 py-1">Professional Fee</td>
              <td className="text-end border-0 font-weight-bold py-1">R {formatCurrency(result.commission)}</td>
            </tr>
            <tr>
              <td className="py-1">Vat on Professional Fee</td>
              <td className="text-end font-weight-bold py-1">R {formatCurrency(result.vatOnCommission)}</td>
            </tr>
            <tr>
              <td className="py-1">Gross Price Less Professional Fee (To Owner)</td>
              <td className="text-end font-weight-bold py-1">R {formatCurrency(result.grossPriceLess)}</td>
            </tr>
            <tr>
              <td className="py-1">Gross Price Plus Professional Fee</td>
              <td className="text-end font-weight-bold py-1">R {formatCurrency(result.grossPricePlus)}</td>
            </tr>
          </tbody>
        </table>
      )}
    </div>
  );
};

export default AgentCommissionPrice;
